import { api } from "../api";
import { IPlatformSettings } from "common/models/settings/IPlatformSettings";

const adminSettingsApi = api
  .enhanceEndpoints({ addTagTypes: ["PlatformSettings"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getPlatformSettings: build.query<IPlatformSettings, void>({
        query() {
          return {
            url: `/admin/settings`,
            method: "GET",
          };
        },
        transformResponse: (result: { settings: IPlatformSettings }) =>
          result.settings,
        providesTags: ["PlatformSettings"],
      }),
      // Форма в админке сохраняет настройки по одной, поэтому тело частичное
      updatePlatformSettings: build.mutation<
        IPlatformSettings,
        Partial<IPlatformSettings>
      >({
        query(body) {
          return {
            url: `/admin/settings`,
            method: "PUT",
            body,
          };
        },
        transformResponse: (result: { settings: IPlatformSettings }) =>
          result.settings,
        invalidatesTags: (result, error) =>
          !error?.status ? ["PlatformSettings"] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetPlatformSettingsQuery,
  useUpdatePlatformSettingsMutation,
} = adminSettingsApi;
